module.exports = __webpack_public_path__ + "static/media/TTlogo.83abad6f.png";